import { NSARouterMakerResult } from "namirasoft-account-react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface SlotListPageProps extends NSARouterMakerResult, FieldProps { }

export default function SlotListPage(props: SlotListPageProps)
{
	return (
		<FieldLayout
			{...props}
			action={{
				description: "This section displays all slots you have created with their basic information."
			}}
			pages={{
				entity: FieldEntities.slot(props),
				list: {}
			}}
		>
			<>
			</>
		</FieldLayout>
	);
}